import { sendMetric, getWhatId, pluralForm } from "@utils";
import { inject, observer } from "mobx-react";
import { useEffect, useState } from "react";

const { VITE_WHAT_ID } = import.meta.env;

import "./style.scss";

const AnimationAva = inject("mainStore")(
    observer(({ mainStore }) => {
        let abTestMetika = mainStore.getMainStore("abTestMetika");
        const what_id = getWhatId() ? getWhatId() : VITE_WHAT_ID;
        const theme = mainStore.getMainStore("theme");
        const preload_data = mainStore.getMainStore("preload_data");
        const wdCd = mainStore.getMainStore("codeTypeMetrika");

        const { preloadWheel } = preload_data;

        const [activeIndex, setActiveIndex] = useState(1);
        const [seconds, setSeconds] = useState(5);

        useEffect(() => {
            const interval = setInterval(() => {
                setActiveIndex((prev) => (prev + 1) % preloadWheel.length);
            }, 1000);

            const intervalSeconds = setInterval(() => {
                setSeconds((prev) => (prev > 0 ? prev - 1 : 1));
            }, 1000);

            return () => {
                clearInterval(interval);
                clearInterval(intervalSeconds);
            };
        }, []);

        useEffect(() => {
            if (seconds < 1) {
                sendMetric(`widget_step_1_show`, {
                    params1: [`${abTestMetika || "ris_promo"}`],
                    params2: null,
                    params3: null,
                    params4: null,
                    params6: null,
                    params7: null,
                    params8: what_id,
                });
                if (window.risMetrika && typeof window.risMetrika.reachgoal_ch === "function") {
                    window.risMetrika.reachgoal_ch({
                        event: "widget_step_1_show",
                        siteId: what_id, //'id витрины',
                        session_uuid: localStorage.getItem("_r_p_s"),
                        widget_code: wdCd ? wdCd : "",
                    });
                }

                mainStore.setMainStore("isVisible", true);
                mainStore.setMainStore("modal", { type: "fortune" });
            }
        }, [seconds]);

        return (
            <div className="animation">
                <span className="animation__title" dangerouslySetInnerHTML={{ __html: themeTitle[theme] || "Здравствуйте! 👋" }} />
                <span className="animation__sub">Вы можете выбрать любой подарок</span>
                <div className="animation__gifts-wrapper">
                    <div
                        className="animation__gifts"
                        style={{
                            transform: `translateX(calc(50% - ${(activeIndex + 0.5) * 181}px))`,
                        }}
                    >
                        {preloadWheel.map((user, idx) => (
                            <div className={`animation__gift ${idx === activeIndex ? "animation__gift_center" : ""}`} key={idx}>
                                <img src={user?.squareLogo} className="animation__gift-img" />
                                <span className="animation__gift-text" dangerouslySetInnerHTML={{ __html: user.title }}></span>
                            </div>
                        ))}
                    </div>
                    <div className="animation__center"></div>
                </div>

                <div className="animation__bottom">
                    <div className="animation__btn">
                        <span className="animation__btn-text">
                            Ваша очередь наступит через {seconds} секунд{pluralForm(seconds, ["у", "ы", ""])}
                        </span>
                        <div className="animation__progress"></div>
                    </div>
                </div>
            </div>
        );
    }),
);

export default AnimationAva;

const themeTitle = {
    magnit: "Подбираем подарки <br/> от партнёров <span class='highlight'>Магнит</span>  🔎",
    wb_with_logo: "Подбираем подарки от\u00A0партнёров\u00A0<span class='highlight'>Wildberries 🔎</span>",
};
